module.exports = __webpack_public_path__ + "41a72ce185780ca17c56a18cc3929fb3.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/StaticPage/ComeBack/assets/Sec-1/bg.jpg
// module id = ./app/containers/StaticPage/ComeBack/assets/Sec-1/bg.jpg
// module chunks = 40